import { useEffect, useRef } from "react";
import gsap from "gsap";

const MainNavigationItem = ({ state, title, img }) => {
    const backgroundRef = useRef(null);
    const imageRef = useRef(null);
    const checkRef = useRef(null);
    const textRef = useRef(null);

    useEffect(() => {
        if (state === 'complete') {
            gsap.to(backgroundRef.current, {
                background: 'rgba(36, 162, 240, 0.3)',
                border: '2px solid rgba(36, 162, 240, 1)',
                duration: 0.25,
            });
            gsap.to(imageRef.current, {
                opacity: 0.3,
                color: 'rgba(0,0,0,0.43)',
                duration: 0.25,
            })
            gsap.to(checkRef.current, {
                opacity: 1,
                duration: 0.25
            });
            gsap.to(textRef.current, {
                opacity: 0,
                duration: 0.25
            });
        }
        else if (state === 'active') {
            gsap.to(backgroundRef.current, {
                background: 'rgba(36, 162, 240, 1)',
                border: '1px solid rgba(0, 0, 0, 0.03)',
                duration: 0.25,
            });
            gsap.to(imageRef.current, {
                opacity: 1,
                color: '#ffffff',
                duration: 0.25,
            })
            gsap.to(checkRef.current, {
                opacity: 0,
                duration: 0.25
            });
            gsap.to(textRef.current, {
                opacity: 1,
                duration: 0.25
            });
        }
        else {
            gsap.to(backgroundRef.current, {
                background: 'rgba(219, 219, 219, 0.3)',
                border: '1px solid rgba(0, 0, 0, 0.06)',
                duration: 0.25,
            });
            gsap.to(imageRef.current, {
                opacity: 0.3,
                color: '#000000',
                duration: 0.25,
            })
            gsap.to(checkRef.current, {
                opacity: 0,
                duration: 0.25
            });
            gsap.to(textRef.current, {
                opacity: 0,
                duration: 0.25
            });
        }

    }, [state]);

    return (
        <>
            <div className="navigation_icon-item">
                <div
                    ref={backgroundRef}
                    className="navigation_icon-item_background" />
                <div
                    ref={imageRef}
                    className="navigation_icon-item_image">
                    {img}
                </div>
                <div
                    ref={checkRef}
                    className="navigation_icon-item_check">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M23.8961 3.14093L9.93444 17.1026L0.765625 7.93375L3.59405 5.10532L9.93444 11.4457L21.0676 0.3125L23.8961 3.14093Z" fill="#24A3F0" />
                    </svg>
                </div>
                <div
                    ref={textRef}
                    className="navigation_icon-item_text">
                    {title}
                </div>
            </div>
        </>
    );
};

export default MainNavigationItem;